import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$freeze from 'babel-runtime/core-js/object/freeze';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import sget from '@xunlei/sget';
import sortBy from '@xunlei/sort-by';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';
import { TreeNode } from '@xunlei/thunder-ui-vue/lib/tree.js';
import CheckBox from '@xunlei/thunder-ui-vue/lib/checkbox.js';
import { isDef, isUndef } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

var NAMESPACE = 'td';

var Table = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-table", class: { 'td-table--border': _vm.bordered, 'td-table--stripe': _vm.striped, 'td-table-tree': _vm.treeEnabled, 'td-table--checkbox': _vm.checkable, 'td-table--hover': _vm.hoverable } }, [_c('div', { staticClass: "td-table__header-wrapper" }, [_c('table', { staticClass: "td-table__header" }, [_c('colgroup', _vm._l(_vm.columns, function (column) {
      return _c('col', { key: column.prop, attrs: { "width": column.width } });
    }), 0), _vm._v(" "), _c('thead', [_c('tr', _vm._l(_vm.columns, function (column, index) {
      return _c('th', { key: column.prop }, [column.sortable ? _c('a', { staticClass: "td-table__text", attrs: { "href": "javascript:;" }, on: { "click": function click($event) {
            return _vm.handleSort(column);
          } } }, [_vm.treeEnabled && index === 0 ? _c('td-icon', { staticClass: "td-tree-node__expand-icon", class: { 'is-expanded': _vm.allExpanded, 'is-hidden': !_vm.allExpandable }, attrs: { "type": "arrow-drop" }, nativeOn: { "click": function click($event) {
            $event.stopPropagation();return _vm.expandAll(!_vm.allExpanded);
          } } }) : _vm._e(), _vm._v(" " + _vm._s(column.label) + " "), _c('td-icon', { class: _defineProperty({ 'is-show': column === _vm.sorting.column }, 'is-' + _vm.sorting.order, column === _vm.sorting.column), attrs: { "type": "sequence" } })], 1) : _c('p', { staticClass: "td-table__text" }, [_vm.treeEnabled && index === 0 ? _c('td-icon', { staticClass: "td-tree-node__expand-icon", class: { 'is-expanded': _vm.allExpanded, 'is-hidden': !_vm.allExpandable }, attrs: { "type": "arrow-drop" }, nativeOn: { "click": function click($event) {
            return _vm.expandAll(!_vm.allExpanded);
          } } }) : _vm._e(), _vm._v(" " + _vm._s(column.label) + " ")], 1)]);
    }), 0)])])]), _vm._v(" "), _c('div', { ref: "bodyWrapper", staticClass: "td-table__body-wrapper", style: { 'max-height': _vm.height + 'px' } }, [_c('div', { ref: "container", staticClass: "td-table__panel", style: { height: _vm.containerHeight + 'px' }, on: { "scroll": _vm.calculateScroll } }, [_c('div', { ref: "phantom-list", staticClass: "td-table__phantom", style: { height: _vm.rowHeight * _vm.sortedRowsLength + 'px' } }), _vm._v(" "), _c('table', { ref: "content", staticClass: "td-table__body" }, [_c('colgroup', _vm._l(_vm.columns, function (column) {
      return _c('col', { key: column.prop, attrs: { "width": column.width } });
    }), 0), _vm._v(" "), _c('tbody', _vm._l(_vm.visibleRow, function (row, index) {
      return _c('tr', { key: index, class: { 'is-checked': _vm.status[row.key].checked }, style: { 'display': _vm.status[row.key].visible ? 'table-row' : 'none' } }, _vm._l(_vm.columns, function (column, index) {
        return _c('td', { key: column.prop }, [index === 0 && (_vm.checkable || _vm.treeEnabled) ? _c('td-tree-node', { attrs: { "label": row[column.prop], "level": row._level, "checked": _vm.status[row.key].checked, "disabled": _vm.status[row.key].disabled, "expanded": _vm.status[row.key].expanded, "indeterminate": _vm.status[row.key].indeterminate, "checkable": _vm.checkable, "tree-enabled": _vm.treeEnabled, "expandable": _vm.sget(row._children, 'length') > 0 }, on: { "change": function change($event) {
              return _vm.check(row.key);
            }, "click-label": function clickLabel($event) {
              return _vm.$emit('click-label', row.key);
            }, "dbclick-label": function dbclickLabel($event) {
              return _vm.$emit('dbclick-label', row);
            }, "update:expanded": function updateExpanded($event) {
              return _vm.expand(row.key);
            } } }, [_vm._t("icon", null, { "slot": "icon", "prop": column.prop, "value": row._row[column.prop], "row": row._row }), _vm._v(" "), _vm._t("default", [_vm._v(" " + _vm._s(row._row[column.prop]) + " ")], { "slot": "label", "prop": column.prop, "value": row._row[column.prop], "row": row._row })], 2) : _c('p', { staticClass: "td-table__text" }, [_vm._t("default", [_vm._v(" " + _vm._s(row._row[column.prop]) + " ")], { "prop": column.prop, "value": row._row[column.prop], "row": row._row })], 2)], 1);
      }), 0);
    }), 0)])])]), _vm._v(" "), _vm.footerEnabled ? _c('div', { staticClass: "td-table__footer-wrapper" }, [_c('table', { staticClass: "td-table__footer" }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col', { attrs: { "width": _vm.footerColWidth } })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', { staticClass: "td-table-tree__cell" }, [_c('td-checkbox', { attrs: { "value": _vm.allChecked, "indeterminate": _vm.allIndeterminate, "disabled": _vm.allSelectedDisabled }, on: { "input": function input($event) {
          return _vm.checkAll();
        } } }, [_vm._t("footer-checkbox", [_vm._v("全选")], { "selectLeafCount": _vm.selectLeafCount })], 2)], 1), _vm._v(" "), _c('td', { staticClass: "td-table-tree__cell" }, [_vm._t("footer")], 2)])])])]) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-table',

  components: {
    TdIcon: Icon,
    TdTreeNode: TreeNode,
    TdCheckbox: CheckBox
  },

  props: {
    columns: Array,
    data: Array,
    height: {
      type: Number,
      default: 500
    },
    defaultCheckedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultExpandedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabledKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bordered: Boolean,
    striped: Boolean,
    checkable: Boolean,
    footerEnabled: Boolean,
    hoverable: Boolean,
    treeEnabled: Boolean,
    footerColWidth: {
      type: Number,
      default: function _default() {
        return 110;
      }
    },
    allSelectedDisabled: {
      type: Boolean,
      default: false
    },
    // table内单行高度, 37是随便定的
    rowHeight: {
      type: Number,
      default: 37
    }
  },

  data: function data() {
    return {
      rows: [],
      checkedKeysCache: null,
      expandedKeysCache: null,
      disabledKeysCache: null,
      checkedRow: [],
      sorting: {
        column: null,
        order: ''
      },
      status: {},
      visibleRow: [],
      top: 0,
      firstElementIndex: 0,
      rowNum: 20, // 可见区域可以显示多少行, 20是随便定的,
      tableScrollTop: 0,
      allExpanded: false,
      sortedRowsLength: 0,
      selectLeafCount: 0
    };
  },


  computed: {
    containerHeight: function containerHeight() {
      return Math.min(this.rowHeight * this.sortedRowsLength, this.height);
    },

    // sortedRows 表示不进行过滤的情况下, 当前已展开的所有可视行(未必创建), 这个方法中demo 30000rows耗时只有50ms左右
    sortedRows: function sortedRows() {
      var _this = this;

      var rows = this.rows.filter(function (row) {
        return _this.status[row.key].visible;
      });

      if (this.sorting.column) {
        rows.sort(function (a, b) {
          return _this.compare(a, b, _this.rows);
        });
      }

      return rows;
    },
    allChecked: function allChecked() {
      return this.checkedRow.length === this.rows.length;
    },
    allIndeterminate: function allIndeterminate() {
      var _this2 = this;

      return !this.allChecked && Boolean(this.rows.find(function (row) {
        return _this2.status[row.key].checked || _this2.status[row.key].indeterminate;
      }));
    },
    allExpandable: function allExpandable() {
      return this.rows.find(function (row) {
        return row._children;
      });
    }
  },

  watch: {
    data: {
      handler: function handler(val) {
        var _this3 = this;

        this.rows = _Object$freeze(this.getRows(val));
        this.initStatus();
        this.allExpanded = this.rows.every(function (row) {
          return _this3.status[row.key].visible;
        });
        this.onDataChange();
      },


      immediate: true
    },
    // resize 时触发
    height: {
      handler: function handler() {
        this.rowNum = Math.floor(this.height / this.rowHeight) + 1;
      },

      immediate: true
    },
    containerHeight: function containerHeight(newVal) {
      this.visibleCount = Math.ceil(newVal / this.rowHeight);
      this.recalculateVisibleRow();
    },

    'sortedRows': {
      handler: function handler(newVal) {
        this.recalculateVisibleRow();
        this.sortedRowsLength = newVal.length;
      },

      immediate: true
    },
    defaultCheckedKeys: 'initStatus',
    defaultExpandedKeys: 'initStatus',
    disabledKeys: 'initStatus'
  },

  methods: {
    sget: sget,
    recalculateVisibleRow: function recalculateVisibleRow() {
      this.start = Math.min(this.start, this.sortedRows.length);
      this.end = this.start + this.visibleCount;
      this.visibleRow = this.sortedRows.slice(this.start, this.end);
    },
    compare: function compare(a, b, origin) {
      var i = 0;
      var pathNodeA = a._path[i];
      var pathNodeB = b._path[i];
      var descending = this.sorting.order === 'descending';
      var column = this.sorting.column;

      while (pathNodeA === pathNodeB) {
        i++;
        pathNodeA = a._path[i];
        pathNodeB = b._path[i];
      }

      return sortBy(function (a, b) {
        if (!a) return -1;
        if (!b) return 1;
        return 0;
      }, function (a, b) {
        var result = 0;

        if (column.sorter) {
          result = column.sorter(a._row, b._row);
        } else {
          var propA = a._row[column.prop];
          var propB = b._row[column.prop];

          if (propA < propB) result = -1;else if (propA > propB) result = 1;
        }

        return descending ? -result : result;
      }, function (a, b) {
        if (origin.indexOf(a) < origin.indexOf(b)) {
          return descending ? 1 : -1;
        } else {
          return descending ? -1 : 1;
        }
      })(pathNodeA, pathNodeB);
    },
    getRows: function getRows(data) {
      var _this4 = this;

      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var rows = [];

      data.forEach(function (row) {
        var newRow = {
          _level: level,
          _parent: parent,
          _row: row,
          key: row.key
        };

        newRow._path = parent ? [].concat(_toConsumableArray(parent._path), [newRow]) : [newRow];
        rows.push(newRow);

        if (row.children) {
          var childrenRows = _this4.getRows(row.children, level + 1, newRow).map(_Object$freeze);

          rows = [].concat(_toConsumableArray(rows), _toConsumableArray(childrenRows));
          newRow._children = childrenRows.filter(function (row) {
            return row._level === level + 1;
          });
          newRow._childrenRows = childrenRows;
        }
      });

      return rows;
    },
    getStatus: function getStatus(rows) {
      var _this5 = this;

      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      rows.forEach(function (row) {
        var parent = status[row._parent && row._parent.key] || {};

        status[row.key] = {
          checked: Boolean(_this5.checkedKeysCache[row.key]),
          disabled: parent.disabled || _this5.disabledKeysCache[row.key],
          expanded: _this5.expandedKeysCache[row.key],
          indeterminate: false,
          visible: row._level === 0 || parent.expanded && parent.visible,
          row: row
        };

        if (row._children) {
          _this5.getStatus(row._children, status);

          status[row.key].checked = row._children.every(function (child) {
            return status[child.key].checked;
          });

          if (!status[row.key].checked && row._children.find(function (child) {
            return status[child.key].checked || status[child.key].indeterminate;
          })) {
            status[row.key].indeterminate = true;
          }
        } else {
          // 选中文件计数
          // this.countSelectFiles({ diff: status[row.key].checked ? 1 : -1 })
          status[row.key].checked && ++_this5.selectLeafCount;
        }
      });

      return status;
    },
    initStatus: function initStatus() {
      var _this6 = this;

      this.checkedKeysCache = {};
      this.expandedKeysCache = {};
      this.disabledKeysCache = {};

      // 初始化默认选中
      this.defaultCheckedKeys.forEach(function (key) {
        _this6.checkedKeysCache[key] = true;
      });

      // 初始化选中文件数目
      // this.countSelectFiles({ value: 0 })
      this.selectLeafCount = 0;

      this.defaultExpandedKeys.forEach(function (key) {
        _this6.expandedKeysCache[key] = true;
      });

      this.disabledKeys.forEach(function (key) {
        _this6.disabledKeysCache[key] = true;
      });

      this.status = this.getStatus(this.rows.filter(function (row) {
        return row._level === 0;
      }));

      var _getCheckedRowAndChec = this.getCheckedRowAndCheckedKey(),
          _getCheckedRowAndChec2 = _slicedToArray(_getCheckedRowAndChec, 2),
          _ = _getCheckedRowAndChec2[0],
          checkedRow = _getCheckedRowAndChec2[1];

      this.checkedRow = checkedRow;
    },


    // countSelectFiles ({ diff, value }) {
    //   if (value !== undefined) {
    //     this.selectLeafCount = value
    //   } else {
    //     this.selectLeafCount += diff
    //   }
    // },

    check: function check(key, checked, checkAll) {
      var _this7 = this;

      var row = this.rows.find(function (row) {
        return row.key === key;
      });

      checked = isDef(checked) ? checked : row._children ? !row._childrenRows.filter(function (row) {
        return !row._children && !_this7.status[row.key].disabled;
      }).every(function (row) {
        return _this7.status[row.key].checked;
      }) : !this.status[row.key].checked;

      var updateChecked = function updateChecked(row, checked) {
        if (row._children) {
          row._children.forEach(function (row) {
            // 当前状态和新的状态不一样
            if (_this7.status[row.key].checked !== checked) {
              updateChecked(row, checked);
            }
          });

          _this7.status[row.key].checked = row._children.every(function (row) {
            return _this7.status[row.key].checked;
          });

          if (_this7.status[row.key].checked) {
            _this7.status[row.key].indeterminate = false;
          } else {
            _this7.status[row.key].indeterminate = Boolean(row._children.find(function (row) {
              return _this7.status[row.key].checked || _this7.status[row.key].indeterminate;
            }));
          }
        } else {
          _this7.status[row.key].disabled || (_this7.status[row.key].checked = checked);

          // 选中文件计数
          // this.countSelectFiles({ diff: this.status[row.key].checked ? 1 : -1 })
          _this7.status[row.key].checked ? ++_this7.selectLeafCount : --_this7.selectLeafCount;
        }
      };

      var updateCheckedUpward = function updateCheckedUpward(row) {
        if (isUndef(row)) return;

        _this7.status[row.key].checked = row._children.every(function (row) {
          return _this7.status[row.key].checked;
        });

        if (_this7.status[row.key].checked) {
          _this7.status[row.key].indeterminate = false;
        } else {
          _this7.status[row.key].indeterminate = Boolean(row._children.find(function (row) {
            return _this7.status[row.key].checked || _this7.status[row.key].indeterminate;
          }));
        }

        updateCheckedUpward(row._parent);
      };

      updateChecked(row, checked);
      updateCheckedUpward(row._parent);
      checkAll || this.emitCheckedChange(key, checked);
    },
    checkAll: function checkAll(checked) {
      var _this8 = this;

      checked = isDef(checked) ? checked : !this.rows.filter(function (row) {
        return !row._children && !_this8.status[row.key].disabled;
      }).every(function (row) {
        return _this8.status[row.key].checked;
      });

      this.rows.filter(function (row) {
        return row._level === 0;
      }).forEach(function (row) {
        // 当前状态和新的状态不一样
        if (_this8.status[row.key].checked !== checked) {
          _this8.check(row.key, checked, true);
        }
      });

      this.$emit('checkAll', checked);
      this.emitCheckedChange();
    },

    // 展开, 只会将当前元素置为可显示状态, 是否实际创建使用滚动事件计算, 不再依赖mounted值
    expand: function expand(key, expanded) {
      var _this9 = this;

      var row = this.rows.find(function (row) {
        return row.key === key;
      });
      expanded = isDef(expanded) ? expanded : !this.status[key].expanded;
      var updateVisible = function updateVisible(row, visible) {
        row._children.forEach(function (innerRow) {
          _this9.status[innerRow.key].visible = visible && _this9.status[innerRow._parent.key].expanded;
          innerRow._children && updateVisible(innerRow, visible);
        });
      };

      this.status[key].expanded = expanded;
      this.status[key].visible && updateVisible(row, expanded);
      this.allExpanded = this.rows.every(function (row) {
        return _this9.status[row.key].visible;
      });
      this.emitExpandedChange(key, expanded);
    },

    // 展开全部, 此时会触发expand
    expandAll: function expandAll(expanded) {
      expanded = isDef(expanded) ? expanded : !this.allExpanded;
      var status = this.status;
      var allExpanded = true;
      var rows = this.rows;
      for (var i = 0, len = rows.length; i < len; i++) {
        var row = rows[i];
        var statusOfRow = status[row.key];
        if (row._level > 0) {
          statusOfRow.visible = expanded;
        }
        if (row._children) {
          statusOfRow.expanded = expanded;
        }
        allExpanded && (allExpanded = allExpanded && statusOfRow.visible);
      }
      this.allExpanded = allExpanded;
      this.emitExpandedChange();
    },
    getCheckedRowAndCheckedKey: function getCheckedRowAndCheckedKey() {
      var checkedKey = [];
      var status = this.status;
      var checkedRow = [];
      for (var key in status) {
        if (status[key].checked) {
          checkedKey.push(key);
          checkedRow.push(status[key].row);
        }
      }
      return [checkedKey, checkedRow];
    },
    emitCheckedChange: function emitCheckedChange(key, checked) {
      var _getCheckedRowAndChec3 = this.getCheckedRowAndCheckedKey(),
          _getCheckedRowAndChec4 = _slicedToArray(_getCheckedRowAndChec3, 2),
          checkedKey = _getCheckedRowAndChec4[0],
          checkedRow = _getCheckedRowAndChec4[1];

      this.checkedRow = checkedRow;
      this.$emit('checked-change', checkedKey, key, checked);
    },
    emitExpandedChange: function emitExpandedChange(key, expanded) {
      var expandKey = [];
      var status = this.status;
      for (var _key in status) {
        status[_key].checked && expandKey.push(_key);
      }
      this.$emit('expanded-change', expandKey, key, expanded);
    },
    handleSort: function handleSort(column) {
      if (this.sorting.column === column) {
        this.sorting.order = this.sorting.order === 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sorting = {
          column: column,
          order: 'ascending'
        };
      }
      this.recalculateVisibleRow();
    },


    // 前后加载元素, 通过设置index来作用
    // 计算可以显示的第一个index, index是相对于sortedRow中的值
    calculateScroll: function calculateScroll(event) {
      var _this10 = this;

      var cb = function cb() {
        var scrollTop = _this10.$refs['container'].scrollTop;
        var fixedScrollTop = scrollTop - scrollTop % _this10.rowHeight;
        _this10.tableScrollTop = fixedScrollTop;
        _this10.$refs.content.style.webkitTransform = 'translate3d(0, ' + fixedScrollTop + 'px, 0)';

        _this10.start = Math.floor(scrollTop / _this10.rowHeight);
        _this10.end = _this10.start + _this10.visibleCount;
        _this10.visibleRow = _this10.sortedRows.slice(_this10.start, _this10.end);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(cb);
      } else {
        cb();
      }
    },
    onDataChange: function onDataChange() {
      var _this11 = this;

      this.$nextTick(function () {
        _this11.visibleCount = Math.ceil(_this11.containerHeight / _this11.rowHeight);
        _this11.start = 0;
        _this11.end = _this11.start + _this11.visibleCount;
        _this11.visibleRow = _this11.sortedRows.slice(_this11.start, _this11.end);
        _this11.$forceUpdate();
      });
    }
  },
  mounted: function mounted() {
    this.onDataChange();
  }
};

Table.install = function (Vue) {
  Vue.component(Table.name, Table);
};

export default Table;
